import { FC } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import clsx from 'clsx'

import Auth from 'store/auth'

import { cutHashFromURL } from 'utils/getURLData'
import { STATIC_PATH_URL, currImageDomain } from 'constants/data'
import { IAttached } from 'constants/types/common.types'
import { popupName } from 'constants/auth/auth-data'
import { iconsData, IMG_EXT } from './data'

import styles from './attached-items.module.scss'

interface IAttachedItems {
  items: IAttached[]
  modificatorWrapper?: string
  modificatorTitle?: string
}

type ItemProp = {
  textName: string
  path?: string
}

const AttachedItem = ({ textName, path }: ItemProp) => {
  const fileExt = textName.split('.').at(-1) as keyof typeof iconsData
  const isImg = IMG_EXT.includes(fileExt)

  return (
    <div className={styles.fileWrapper}>
      <div
        className={clsx(styles.preview, { [styles.previewWithBg]: isImg })}
        style={{
          backgroundImage: isImg ? `url(${currImageDomain}${STATIC_PATH_URL}${path})` : 'none',
        }}
      >
        <Image className={clsx(styles.icon, { [styles.imgIcon]: isImg })} {...iconsData[fileExt]} />
      </div>
      <p className={styles.fileName}>{textName}</p>
    </div>
  )
}

const AttachedItems: FC<IAttachedItems> = ({
  items,
  modificatorWrapper,
  modificatorTitle,
}: IAttachedItems) => {
  const router = useRouter()
  const { isAuthorized } = Auth.useAuth()

  const cleanPath = cutHashFromURL(router.asPath)

  const openRegistrPopup = () =>
    router.push(`${cleanPath}#${popupName.registration}`, undefined, { shallow: true })

  return (
    <>
      <div
        className={clsx(styles.attachedItems, {
          [modificatorWrapper as string]: modificatorWrapper,
        })}
      >
        <h3 className={clsx(styles.title, { [modificatorTitle as string]: modificatorTitle })}>
          Прикрепленные материалы
        </h3>
        <div className={styles.attachedBox}>
          {isAuthorized
            ? items.map(({ fileName, textName, path }) => (
                <a
                  href={`${currImageDomain}${STATIC_PATH_URL}${path}`}
                  className={styles.attachedItem}
                  key={fileName}
                  data-text={textName}
                  target="_blank"
                  rel="noreferrer"
                >
                  <AttachedItem textName={textName} path={path} />
                </a>
              ))
            : items.map(({ fileName, textName, path }) => (
                <div className={styles.attachedItem} key={fileName} onClick={openRegistrPopup}>
                  <AttachedItem textName={textName} path={path} />
                </div>
              ))}
        </div>
      </div>
    </>
  )
}

export default AttachedItems
